import { Grid, TextField } from "@mui/material";
import { useGetMyPointQuery } from "app/apiSlice";
import CustomButton from "components/button/CustomButton";
import TravelPackCard from "components/lottecard/TravelPackCard";
import CardLayout from "components/layout/CardLayout";
import useFormatPrice from "hooks/useFormatPrice";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { ProviderUtils } from "utils/providerUtils";

interface PointSectionProps {
  point: string;
  setPoint: React.Dispatch<React.SetStateAction<string>>;
  priceToPay: number;
}

const PointSection = ({ point, setPoint, priceToPay }: PointSectionProps) => {
  const intl = useIntl();
  const formatPrice = useFormatPrice();
  // const userPoint = useFetchPoint();

  const { data: userPoint } = useGetMyPointQuery();

  const numericPoint = Number(point.replaceAll(",", ""));

  const [isFocused, setIsFocused] = useState(false);

  const getHeader = () => {
    return (
      <p className="font-bold">{intl.formatMessage({ id: "point.point" })}</p>
    );
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    if (Number(value) > (userPoint || 0)) {
      alert(intl.formatMessage({ id: "point.cannotExceedPointsHeld" }));
      return;
    }

    setPoint(`${Number(value)}`);
  };

  const handleFocus = () => {
    setIsFocused(true);
    setPoint(`${numericPoint || "0"}`);
  };

  const handleBlur = () => {
    setIsFocused(false);
    // if (numericPoint > userPoint) {
    //   alert(intl.formatMessage({ id: "point.cannotExceedPointsHeld" }));
    //   setPoint("0");
    //   return;
    // }
    setPoint(`${numericPoint.toLocaleString('ko-kr')}`);
  };

  const handleClick = () => {
    setPoint(`${Math.min(userPoint || 0, priceToPay).toLocaleString('ko-kr')}`);
  };

  return (
    <CardLayout header={getHeader()}>
      <Grid
        container
        justifyContent="space-between"
        alignItems="end"
        spacing={1}
        rowSpacing={1}
      >
        <Grid item xs={7} sx={{ textAlign: "start" }}>
          <p>{intl.formatMessage({ id: "point.points_held" })} </p>
        </Grid>
        <Grid item xs={5} sx={{ textAlign: "end" }}>
          <p className="font-bold text-error">{formatPrice(userPoint)}</p>
        </Grid>
        <Grid item xs={9}>
          <TextField
            type={isFocused ? "number" : "text"}
            fullWidth
            name="passengerName"
            value={point}
            // onChange={onChangePassengerDetail(index, "name")}
            placeholder={"0"}
            InputProps={{
              inputProps: { min: 0, max: userPoint },
              sx: {
                height: "48px",
                "& .MuiInputBase-input": {
                  textAlign: "end",
                },
                "& input[type=number]": {
                  "-moz-appearance": "textfield",
                  margin: 0.3,
                },
                "& input[type=number]::-webkit-outer-spin-button": {
                  "-webkit-appearance": "none",
                  margin: 0.3,
                },
                "& input[type=number]::-webkit-inner-spin-button": {
                  "-webkit-appearance": "none",
                  margin: 0.3,
                },
                "& input[type=text]": {
                  "-moz-appearance": "textfield",
                  margin: 1,
                },
                "& input[type=text]::-webkit-outer-spin-button": {
                  "-webkit-appearance": "none",
                  margin: 1,
                },
                "& input[type=text]::-webkit-inner-spin-button": {
                  "-webkit-appearance": "none",
                  margin: 1,
                },
              },
              endAdornment: intl.formatMessage({ id: "payment.koreanWon" }),
            }}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
        </Grid>
        <Grid item xs={3} alignSelf={"center"}>
          <CustomButton
            size="large"
            onClick={handleClick}
            disabled={Math.min(userPoint || 0, priceToPay) === numericPoint}
          >
            {intl.formatMessage({ id: "point.useAll" })}
          </CustomButton>
        </Grid>
      </Grid>
      <p className="my-2 text-sm text-text-secondary">
        {intl.formatMessage({
          id: "point.using_points_decreases_payment_amount",
        })}
      </p>

      {/* 롯데카드 트래블팩 */}
      {ProviderUtils.provider?.provider === "lottetest" && (
        <TravelPackCard text={"트래블팩 구독하면 매월 1천원 적립"} chevron />
      )}
    </CardLayout>
  );
};

export default PointSection;
